import React, { useState, useEffect } from 'react';
import PinwheelView from './Pinwheel.view';
import { runPinwheel } from '../../../services/integrationsService';

const onSuccess = (clientId, requestId, setHasError) => async (data) => {
  try {
    await runPinwheel(
      requestId,
      clientId,
      { data },
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error running Pinwheel integration', error);
    setHasError(true);
  }
};

const handleError = (setHasError) => (error) => {
  // eslint-disable-next-line no-console
  console.error('Received Pinwheel Error:', error);
  return setHasError(true);
};

export default function PinwheelContainer(props) {
  const { requestId, clientId, onCompleted } = props;
  const [token, setToken] = useState(false);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    async function fetchData() {
      const result = await runPinwheel(requestId, clientId, {});
      await setToken(result[0].token);
    }
    fetchData();
  }, [requestId, clientId]);
  return (
    <PinwheelView
      hasError={hasError}
      loading={!token}
      onError={handleError(setHasError)}
      onExit={onCompleted}
      onSuccess={onSuccess(clientId, requestId, setHasError)}
      token={token}
    />
  );
}
